import classNames from 'classnames';
import { type FragmentType, getFragmentData, graphql } from 'client/gql';
import { BpCalendar } from 'components/BpCalendar/BpCalendar';
import { BpCard } from 'components/BpCard/BpCard';
import { EventsList } from 'components/EventsList/EventsList';
import { useState } from 'react';
import { findClosestEventToNow } from 'utils/dateCalculations';
import styles from './DashboardEvents.module.scss';
import { getDashboardEvents } from './getDashboardEvents';

const DashboardEventsFieldsDocument = graphql(`
  fragment DashboardEventsFields on Query {
    ...DashboardEventsQueryFields
  }
`);

// Type for the event click handler
type EventClickHandler = (uuid: string) => void;

type DashboardEventsProps = {
  query: FragmentType<typeof DashboardEventsFieldsDocument> | undefined;
  isOrganizationAdmin: boolean;
  profileUuid: string;
  onAdd?: (edit: boolean) => void;
  onEdit?: (uuid: string) => void;
};

export function DashboardEvents({ isOrganizationAdmin, profileUuid, onAdd, onEdit, query }: DashboardEventsProps) {
  const fragment = getFragmentData(DashboardEventsFieldsDocument, query);
  const dashboardEvents = getDashboardEvents(fragment, profileUuid, isOrganizationAdmin);
  const closestEvent = findClosestEventToNow(dashboardEvents);
  const [scrollUuid, setScrollUuid] = useState<string | null>(closestEvent ? closestEvent.uuid : null);
  const [randomRedrawString, setRandomRedrawString] = useState<string>('');
  const handleEventClick: EventClickHandler = (uuid: string): void => {
    setRandomRedrawString(Date.now().toString());
    setScrollUuid(uuid);
  };

  return (
    <div className={classNames(styles.tab, styles['calendar-tab'])}>
      <BpCard className={styles.calendar} noPadding showBorder hideBackground>
        <BpCalendar
          events={dashboardEvents}
          showAddButton={isOrganizationAdmin}
          onAdd={onAdd}
          isOnWhite
          eventClick={handleEventClick}
        />
      </BpCard>
      <EventsList
        className={styles.events}
        isOnWhite
        showCompactEvents
        minWidth='60%'
        events={dashboardEvents}
        onEdit={onEdit}
        scrollToUuid={scrollUuid}
        randomRedrawString={randomRedrawString}
      />
    </div>
  );
}
